{
  "Accessibility menu": "Tilgjengelighetsmeny",
  "Close": "Lukk",
  "Content adjustments": "Innholdsjusteringer",
  "Navigation adjustments": "Navigasjonsjusteringer",
  "Align Left": "Venstrejuster",
  "Adjust Font Size": "Juster skriftstørrelse",
  "Highlight Title": "Fremhev tittel",
  "Highlight Links": "Fremhev lenker",
  "Readable Font": "Lesbar skrift",
  "Colour adjustments": "Fargejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høy kontrast",
  "High Saturation": "Høy metning",
  "Low Saturation": "Lav metning",
  "Monochrome": "Monokrom",
  "Tools": "Verktøy",
  "Reading Guide": "Leseguide",
  "Big Cursor": "Stor markør",
  "Increase Font Size": "Øk skriftstørrelse",
  "Decrease Font Size": "Reduser skriftstørrelse",
  "Letter Spacing": "Bokstavavstand",
  "Line Height": "Linjehøyde",
  "Font Weight": "Skrifttykkelse",
  "Dyslexia Font": "Dysleksi-skrift",
  "Language": "Språk",
  "Accessibility widget": "Tilgjengelighetswidget",
  "Accessibility Profiles": "Tilgjengelighetsprofiler",
  "Cognitive Disability": "Kognitiv funksjonshemming",
  "Seizure Safe": "Epilepsisikker",
  "Accessibility statement": "Tilgjengelighetserklæring",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Stopp animasjoner",
  "Reset all settings": "Tilbakestill innstillinger",
  "Shortcut:": "Shortcut:"
}
